import { uniqBy } from 'lodash';
import { useContext, useRef, useState } from 'react';
import { eAlertType } from '../../../../../../../../providers/ToastProvider/Toast.enum.ts';
import { useToastContext } from '../../../../../../../../providers/ToastProvider/Toast.hook.ts';
import { useUserContext } from '../../../../../../../../providers/UserProvider/User.context.ts';
import { useWorkspaceContext } from '../../../../../../../../providers/WorkspaceProvider/Workspace.context.ts';
import { useChatContext } from '../../../../../../Chat.hook.ts';
import { tDriveFile } from '../../../../../../Chat.types.ts';
import { DriveFilesActionContext } from './DriveFilesAction.constants.ts';
import { DriveFilesActionService } from './DriveFilesAction.service.ts';
import {
  tDriveFilesActionContext,
  tDriveFilesActionHook,
} from './DriveFilesAction.types.ts';

export function useDriveFileAction(): tDriveFilesActionHook {
  const { addAlert } = useToastContext();
  const { currentWorkspace } = useWorkspaceContext();
  const { currentUserId } = useUserContext();
  const { selectedChat, setSelectedChat } = useChatContext();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<tDriveFile[]>([]);
  const [showUploadFile, setShowUploadFile] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const fileRef = useRef<HTMLInputElement>(null);
  const [saveOnDrive, setSaveOnDrive] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const [cursor, setCursor] = useState(selectedChat?.driveFiles.cursor || '');

  async function getMoreLeads(cursor: string) {
    try {
      if (!currentWorkspace?.id || !currentUserId) return null;

      const response = await DriveFilesActionService.getMoreFiles(
        currentWorkspace.id,
        cursor,
      );

      if (!response || !response.data) {
        throw new Error('No se recibieron más Archivos');
      }

      setSelectedChat((prevChat) => {
        if (!prevChat) return prevChat;

        // Combinamos los archivos existentes con los nuevos y eliminamos duplicados por ID
        const newFiles = uniqBy(
          [
            ...(prevChat.driveFiles.files || []),
            ...(response.data?.files || []),
          ],
          'id',
        );
        return {
          ...prevChat,
          driveFiles: {
            ...prevChat.driveFiles,
            files: newFiles,
          },
        };
      });

      return response.data.cursor;
    } catch (err) {
      addAlert({
        type: eAlertType.ERROR,
        message:
          (err as Error).message ||
          'Error al acceder al servidor para traer mas leads',
      });
      return null;
    }
  }

  return {
    isDropdownOpen,
    setIsDropdownOpen,
    dropdownRef,
    setSelectedFiles,
    selectedFiles,
    fileRef,
    setShowUploadFile,
    showUploadFile,
    saveOnDrive,
    setSaveOnDrive,
    isLastPage,
    setIsLastPage,
    cursor,
    setCursor,
    getMoreLeads,
  };
}

export const useDriveFilesActionContext = (): tDriveFilesActionContext => {
  return useContext(DriveFilesActionContext);
};
